<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ordersView from "@/components/orders/ordersView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, ordersView },
    data() {
        return {
            title: "Orders",
            items: [
                {
                    text: "Utility",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ordersView />
    </Layout>
</template>
